import { gatewayApi } from "@/shared/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
  "auth/signInUser",
  async ({ username, password }: any, { dispatch }) => {
    const { result } = await dispatch(
      gatewayApi.endpoints.login.initiate({ username, password })
    ).unwrap();

    return result;
  }
);

export const logout = createAsyncThunk(
  "auth/logOutUser",
  async (_, { dispatch }) => {
    const {
      data: { result },
    } = await dispatch(gatewayApi.endpoints.logout.initiate()).unwrap();

    return result;
  }
);
